import { Component, OnInit, inject } from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import { Router, RouterLink } from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {environment} from '../../environments/environment';
import {BillsPerEj, IBillsPerEj} from '../../shared/model/billsPerEj.model';
import {AccountService} from '../core/auth/account.service';
import {IEj} from '../../shared/model/ej.model';
import {filter, map} from 'rxjs/operators';
import {IBill} from "../../shared/model/bill.model";
import {detect} from "detect-browser";
import { MatCard, MatCardTitle, MatCardContent, MatCardFooter } from '@angular/material/card';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatFooterCellDef, MatFooterCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFooterRowDef, MatFooterRow } from '@angular/material/table';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { DecimalPipe, DatePipe } from '@angular/common';

@Component({
    selector: 'app-bills',
    templateUrl: './bills.component.html',
    styleUrls: ['./bills.component.css'],
    imports: [MatCard, MatCardTitle, MatProgressSpinner, RouterLink, MatCardContent, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatFooterCellDef, MatFooterCell, MatIcon, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFooterRowDef, MatFooterRow, MatCardFooter, MatButton, DecimalPipe, DatePipe]
})
export class BillsComponent implements OnInit {
  private http = inject(HttpClient);
  private router = inject(Router);
  private toastr = inject(ToastrService);
  private accountService = inject(AccountService);


  ejs: IEj[] = [];
  billsPerEjList: IBillsPerEj[];
  isLoading = true;
  noEjs = false;
  // errTxt: string;
  apiUrl = environment.apiUrl;
  displayedColumns: string[] = ['label', 'itemDateDueTrans', 'amount', 'bill', 'payment'];
  downloadBillClicked = false;
  showBanner = false;
  showNoBills = false;
  bodyBanner: string;

  ngOnInit(): void {
    this.showNoBills = false;

    this.accountService.fetchEjs().then(value => {
      this.ejs = value;
    }).catch(() => {
      this.showError('Une erreur est survenue');
    });

    this.http.get<IBillsPerEj[]>(this.apiUrl + '/bills/get-bills', {observe: 'response'})
      .pipe(
        filter((res: HttpResponse<IBillsPerEj[]>) => res.ok),
        map((res: HttpResponse<IBillsPerEj[]>) => res.body)
      )
      .subscribe((respGetBills: IBillsPerEj[]) => {
        this.billsPerEjList = respGetBills;
        this.initBanner(this.billsPerEjList);
        this.isLoading = false;
        this.showNoBills = !this.hasBills();
      }, () => {
        this.showError('Impossible de récupérer vos factures');
        this.noEjs = true;
        this.isLoading = false;
        this.showNoBills = !this.hasBills();
      });
  }

  public hasPrl(billsPerEj: BillsPerEj): boolean {
    return billsPerEj.factures.some(bill => bill.itemModePayment === 'PVL');
  }

  public hasBills(): boolean {
    return this.billsPerEjList && this.billsPerEjList.length >= 1;
  }

  public closeBanner(): void {
    this.showBanner = false;
  }

  canUseMandat(ej: string): boolean {
    if (ej === null) {
      return this.accountService.canUseMandat();
    }
    return this.ejs.some(e => e.codeEj === ej);
  }

  public totalAmountCalculator(respGetBills: IBill[]): number {
    const sum = respGetBills
      .map(item => item.itemAmountRemainingIncTax)
      .reduce((prev, curr) => prev + curr, 0);

    return parseFloat(String(sum));
  }

  public isValidDateForPdf(bill: IBill): boolean {
    const dateBill = new Date(bill.itemDateIssue);
    const currentDate = new Date();
    const compareDate = new Date(dateBill.getFullYear() + 3, dateBill.getMonth(), dateBill.getDay());

    return compareDate.getTime() > currentDate.getTime();
  }

  private showError(error: string) {
    this.toastr.error(error, 'Erreur', {
      timeOut: 3000
    });
  }

  public openBill(bill: IBill, ej: string): void {
    this.isLoading = true;
    this.downloadBillClicked = true;
    const body = {
      uniqueId: bill.itemUniqueKey,
      ej,
      type: bill.naturePiece
    };
    this.http.post(this.apiUrl + '/bills/download-bill', body, {observe: 'response', responseType: 'text'})
      .pipe(
        filter((res: HttpResponse<string>) => res.ok),
        map((res: HttpResponse<string>) => res.body)
      )
      .subscribe((response: string) => {
        this.isLoading = false;
        this.downloadBillClicked = false;

        const binary_string = window.atob(response.replace(/\s/g, ''));
        const len = binary_string.length;
        const buffer = new ArrayBuffer(len);
        const bytes = new Uint8Array(buffer);
        for (let i = 0; i < len; i++) {
          bytes[i] = binary_string.charCodeAt(i);
        }
        const file = new Blob([bytes], {type: 'application/pdf'});
        const fileURL = window.URL.createObjectURL(file);
        const filename = fileURL.replace(/^.*[\\/]/, '');

        const browser = detect();
        if (browser.os === 'iOS' || browser.name === 'firefox' || browser.name === 'edge-chromium') {
          const a = document.createElement('a');
          a.target = "_blank";
          a.href = fileURL;
          a.download = filename;
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();
          a.remove();
        } else {
          window.open(fileURL, '_blank');
        }
      }, (error: string) => {
        switch (error) {
          case 'ERR_GET_BILL':
            this.showError('Problème lors de la génération de la facture');
            break;

          default:
            this.showError('Une erreur s\'est produite');
            break;
        }
        this.isLoading = false;
        this.downloadBillClicked = false;
      });
  }

  public openPaymentLink(linkId: string): void {
    this.router.navigate(['paiement/checkout', linkId]).then();
  }

  redirectToMandat(billsPerEj: BillsPerEj): void {
    this.router.navigate(['/mandat/sign'], {queryParams: {ej: billsPerEj.ej}}).then();
  }

  private initBanner(billsPerEjList: IBillsPerEj[]) {
    const billToPay = billsPerEjList.some(billsPerEj => this.totalAmountCalculator(billsPerEj.factures) > 0);

    if (this.accountService.canUseMandat()) {
      // si montant facture à payer est supérieur à 0
      if (billToPay) {
        this.bodyBanner = 'Vous avez des factures non réglées. Pour gagner du temps, ';
      } else {
        this.bodyBanner = 'Pour gagner du temps, ';
      }
      this.showBanner = true;
    }
  }

  public displayPaymentCard(bill: IBill): boolean {
    return bill.enableCardPayment && (bill.paymentLink!=undefined || bill.paymentLink!=null || bill.paymentLink!='');
  }
}
